import { Component, inject, signal } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { CookiePreferences } from '../models/cookie-preferences.model';
import { CookieCategory } from '../models/cookie-category.model';

@Component({
    selector: 'app-cookie-preferences',
    imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatIconModule,
    MatDividerModule
],
    templateUrl: './cookie-preferences.component.html',
    styleUrl: './cookie-preferences.component.scss'
})
export class CookiePreferencesComponent {
  protected preferences = signal<CookiePreferences>({
    essential: true,
    analytics: false,
    marketing: false
  });

  protected showDetails = signal<Record<string, boolean>>({
    essential: false,
    analytics: false,
    marketing: false
  });

  protected categories = signal<CookieCategory[]>([
    {
      key: 'essential',
      title: 'Cookie-uri esențiale',
      description: 'Necesare pentru funcționarea de bază și securitatea site-ului. Nu pot fi dezactivate.',
      required: true,
      enabled: true,
      details: [
        'Token-uri de autentificare pentru conectarea securizată',
        'Cookie-uri de sesiune pentru funcționalitatea site-ului',
        'Cookie-uri Google OAuth pentru autentificarea cu Google',
        'Preferințe de securitate și validare CSRF'
      ]
    // },
    // {
    //   key: 'analytics',
    //   title: 'Cookie-uri de analiză',
    //   description: 'Ne ajută să înțelegem cum utilizați site-ul pentru a îmbunătăți experiența utilizatorilor.',
    //   required: false,
    //   enabled: false,
    //   details: [
    //     'Statistici de utilizare anonymizate',
    //     'Informații despre paginile vizitate',
    //     'Durata sesiunilor și rata de revenire',
    //     'Date demografice generale (fără identificare personală)'
    //   ]
    // },
    // {
    //   key: 'marketing',
    //   title: 'Cookie-uri de marketing',
    //   description: 'Utilizate pentru a vă afișa anunțuri relevante și pentru a măsura eficiența campaniilor.',
    //   required: false,
    //   enabled: false,
    //   details: [
    //     'Preferințe publicitare personalizate',
    //     'Urmărirea conversiilor din campaniile publicitare',
    //     'Cookie-uri de retargeting pentru anunțuri relevante',
    //     'Integrare cu platformele de social media'
    //   ]
     }
  ]);

  constructor(private matDialogRef: MatDialogRef<CookiePreferencesComponent>, private cookieService: CookieConsentService) {
    // Load current preferences
    const currentPrefs = this.cookieService.getCurrentPreferences();
    this.preferences.set(currentPrefs);
    
    // Update categories with current preferences
    this.updateCategoriesFromPreferences(currentPrefs);
  }

  /**
   * Update a specific preference
   */
  updatePreference(key: keyof CookiePreferences, enabled: boolean): void {
    const current = this.preferences();
    const updated = { ...current, [key]: enabled };
    this.preferences.set(updated);
    this.updateCategoriesFromPreferences(updated);
  }

  /**
   * Toggle details visibility for a category
   */
  toggleDetails(categoryKey: string): void {
    const current = this.showDetails();
    this.showDetails.set({
      ...current,
      [categoryKey]: !current[categoryKey]
    });
  }

  /**
   * Save preferences and close dialog
   */
  savePreferences(): void {
    this.matDialogRef.close(this.preferences());
  }

  /**
   * Cancel and close dialog
   */
  cancel(): void {
    this.matDialogRef.close(null);
  }

  /**
   * Update categories enabled state from preferences
   */
  private updateCategoriesFromPreferences(prefs: CookiePreferences): void {
    const current = this.categories();
    const updated = current.map(category => ({
      ...category,
      enabled: prefs[category.key]
    }));
    this.categories.set(updated);
  }
}
